export default "__VITE_ASSET__BM0O7N1t__"